<ph-card heading="Invoice details" fill flat>
    <app-payable-status-badge *ngIf="localPayable?.id" slot="actions" [payable]="localPayable"></app-payable-status-badge>

    <form [formGroup]="payableFormGroup">
        <ph-field>
            <ph-label required>Vendor</ph-label>
            <ph-select formControlName="vendorId" ngDefaultControl [items]="vendorItems" placeholder="Select or Create a Vendor" (ph-change)="checkAddVendor($event.detail)"></ph-select>
            <ph-spinner *ngIf="vendorsLoading" size="16"></ph-spinner>
            <ph-hint *ngIf="selectedVendorAddress">{{ selectedVendorAddress }}</ph-hint>
            <ph-link-button *ngIf="selectedVendor && hasWriteAccess"
                            variant="primary"
                            size="small"
                            (click)="updateSelectedVendor()">Update vendor details</ph-link-button>
        </ph-field>

        <ph-toolbar>
            <ph-field>
                <ph-label required>Invoice Date</ph-label>
                <ph-date-input formControlName="invoiceDate" ngDefaultControl placeholder="Invoice date"></ph-date-input>
            </ph-field>
            <ph-field>
                <ph-label required>Invoice Due Date</ph-label>
                <ph-date-input formControlName="dueDate" ngDefaultControl placeholder="Due date"></ph-date-input>
            </ph-field>
        </ph-toolbar>

        <ph-field>
            <ph-label>Invoice #</ph-label>
            <ph-input formControlName="invoiceNumber" ngDefaultControl placeholder="Vendor invoice number"></ph-input>
        </ph-field>

        <ph-field>
            <ph-label required>Invoice Amount</ph-label>
            <ng-container *ngIf="!localPayable || localPayable?.statusDescription === 'Draft' || localPayable?.paymentSentAt; else readOnlyAmount">
                <ph-money-input formControlName="amount" ngDefaultControl [hasError]="totalAmountInvalid" placeholder="Amount"></ph-money-input>
            </ng-container>
            <ng-template #readOnlyAmount>
                <ph-toolbar>
                    <div>{{ (localPayable?.paymentAmount | legfiCurrency:'USD':'symbol':'.2') ?? 'n/a' }}</div>
                    <ph-tooltip text="Return the payable to draft status and re-confirm in order to change the invoice/payment amount.">
                        <ph-button variant="secondary" mode="ghost" icon-only icon="info" size="xsmall" aria-label="Why this is read only"></ph-button>
                    </ph-tooltip>
                </ph-toolbar>
            </ng-template>
        </ph-field>

        <!-- Expense Categories Form Component -->
        <ph-field>
        <app-expense-categories-form
            [parentFormGroup]="payableFormGroup"
            [organizationId]="organizationId"
            [hasAccrualAccounting]="hasAccrualAccounting"
            [totalAmount]="getTotalAmount()"
            [invalidControls]="invalidControls"
            [readonly]="isProcessing"
            [defaultCategory]="selectedVendor?.category"
            [existingExpenseCategories]="localPayable?.expenseCategories || []"
            (expenseCategoriesLoadingChange)="expenseCategoriesLoading = $event"
        ></app-expense-categories-form>
        </ph-field>

        <ph-field>
            <ph-label>Memo</ph-label>
            <ph-textarea formControlName="memo" ngDefaultControl rows="2" placeholder="Other invoice details"></ph-textarea>
        </ph-field>
    </form>
</ph-card>

<app-vendor-editor-dialog [open]="vendorEditorOpen" [vendorId]="vendorEditorVendorId" (closed)="onVendorEditorClosed($event)"></app-vendor-editor-dialog>
